import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { InsuranceStatus } from '@40seas/entities/insurance';
import { Currency } from '@40seas/models';
import { z } from 'zod';

export const BusinessInsuranceSchema = z.object({
    status: EnumSchema(InsuranceStatus),
    requestedAmount: z.number(),
    coverAmount: z.number().optional(),
    currency: EnumSchema(Currency),
    provider: z.string(),
    companyId: z.string().optional(),
    grade: z.string().optional(),
});

export class BusinessInsurance extends FromSchema(BusinessInsuranceSchema) {
    status: InsuranceStatus;
    requestedAmount: number;
    coverAmount?: number;
    currency: Currency;
    provider: string;
    companyId?: string;
    grade?: string;
}
